import { Box } from '@material-ui/core';
import { LenderName } from '@nemuru-eng/js-api-client';

import { LenderIcons } from '@/components/modules/Application/components/PaymentMethod/_shared/components/LenderIcons';
import { AbstractLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractLoanPaymentMethod';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';
import { BnplPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/Bnpl/entities/PaymentMethod/BnplPaymentMethod';
import { ConsumerLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/ConsumerLoan/entities/PaymentMethod/ConsumerLoanPaymentMethod';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { IconWithCircle } from '@/components/shared/components/IconWithCircle';
import { IconByAllowedPaymentMethodType } from '@/components/shared/components/PricingsTable/constants/IconByAllowedPaymentMethodType';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface LoanPaymentMethodSummaryCardProps {
  paymentMethodEntity: ConsumerLoanPaymentMethod | BnplPaymentMethod | AutoLoanPaymentMethod;
  activeLenders?: LenderName[];
  available?: boolean;
}

export const LoanPaymentMethodSummaryCard = ({
  paymentMethodEntity,
  activeLenders,
  available,
}: LoanPaymentMethodSummaryCardProps) => {
  const { palette } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems={'center'} gridGap={16} py={1} width={'100%'}>
        <Box display={'flex'} alignItems={'center'} gridGap={16}>
          <Icon size={20} color={available === false ? palette.error.main : palette.secondary.main}>
            {IconByAllowedPaymentMethodType(paymentMethodEntity.paymentMethodType)}
          </Icon>
          <Box display={'flex'} flexDirection={'column'}>
            <Font variant={'caption'} color={available === false ? 'error' : 'textPrimary'}>
              {getTextIdTranslation(`${paymentMethodEntity.paymentMethodType}_SHORT`)}
            </Font>

            <Font variant={'body2'} color={available === false ? 'error' : 'textPrimary'}>
              {!paymentMethodEntity.selectedConditionsGroup ? (
                <></>
              ) : (
                <strong>
                  {getTextIdTranslation(
                    paymentMethodEntity.selectedConditionsGroup.instalmentTotalAmount().hasMultiple
                      ? 'FROM_AMOUNT'
                      : 'FOR',
                  )?.toLowerCase()}{' '}
                  {paymentMethodEntity.selectedConditionsGroup.instalmentTotalAmount().string}{' '}
                  {getTextIdTranslation('PER_MONTH')}
                </strong>
              )}
            </Font>
          </Box>
        </Box>
        {available === true && <IconWithCircle color={palette.success.main}>check</IconWithCircle>}
        {available === false && <IconWithCircle color={palette.error.main}>error</IconWithCircle>}
        {available === undefined && (
          <LenderIcons
            allLenderNames={
              (paymentMethodEntity as unknown as AbstractLoanPaymentMethod).getAllProviderNames() as LenderName[]
            }
            activeLenderNames={
              activeLenders ??
              ((paymentMethodEntity as unknown as AbstractLoanPaymentMethod).getActiveProviderNames() as LenderName[])
            }
            size={16}
          />
        )}
      </Box>
    </>
  );
};
